import { ElementType, ReactNode } from "react";

import { BodyXL } from "./BodyXL";
import { cn } from "@verse_core/shared_components/ClassName";

type BodyProps = {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
  as?: ElementType;
};

export const BodyXLB = ({
  children,
  className,
  as: Component = "p",
  dataTestId,
}: BodyProps) => {
  return (
    <BodyXL
      className={cn("tw-font-medium", className)}
      as={Component}
      dataTestId={dataTestId}
    >
      {children}
    </BodyXL>
  );
};
